import api from "./api";

// Capa de servicios API del dominio "solicitudes web" (doc 0398).
// Wrappers de transporte finos: el endpoint en un único sitio, la construcción
// de params en el componente — mismo criterio que appointments.api.js.

export const listWebLeads = (params) => api.get("/web-leads", { params });

// Solo el número — sin listado — para el badge del menú lateral "Agenda".
export const getUnseenWebLeadsCount = () => api.get("/web-leads/unseen-count");

export const updateWebLeadStatus = (id, status) =>
  api.patch(`/web-leads/${id}/status`, { status });

// Borrado real (no cambia status) — solo admin/super, el backend lo exige
// (0421). Distinto de updateWebLeadStatus(id, "descartada").
export const deleteWebLead = (id) => api.delete(`/web-leads/${id}`);
